import { render, staticRenderFns } from "./loading-new.vue?vue&type=template&id=7b3ed96c&scoped=true&"
import script from "./loading-new.vue?vue&type=script&lang=js&"
export * from "./loading-new.vue?vue&type=script&lang=js&"
import style0 from "./loading-new.vue?vue&type=style&index=0&id=7b3ed96c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b3ed96c",
  null
  
)

export default component.exports